import { Button } from '@components/atoms/Button';
import { Checkbox } from '@components/atoms/Checkbox';
import { media, styled } from '@styles';
import { baseFontColor } from '@styles/constants';

export const ContactsForm = styled.form`
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const RowWithTwoCells = styled.div<{
  margin?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${(props) => props.margin && 'margin-bottom: 0px;'}
  & > div {
    width: calc(50% - 10px / 2);
    ${media.xSmallScreen`
      width: 100%;
    `}
  }
  ${media.largeScreen`
    ${(props: { margin: any }) => props.margin && 'margin-bottom: 0px;'}
  `}
`;

export const RowWithOneCell = styled.div<{
  margin?: boolean;
}>`
  ${(props) => props.margin && 'margin-bottom: 0px;'}
  width: 100%;
  ${media.largeScreen`
    ${(props: { margin: any }) => props.margin && 'margin-bottom: 0px;'}
  `}
`;

export const StyledButton = styled(Button)`
  margin: 36px auto 0;
  width: 300px;
  height: 64px;
  display: block;
  ${media.mediumScreen`
    margin: 20px auto 0;
    width: 160px;
    height: 48px;
  `}
`;

export const CharactersCounter = styled.div`
  width: 100%;
  margin: -5px 0 5px;
  font-size: ${(props) => props.theme.typography.labelFontSize};
  color: #cfd7da;
  text-align: right;
`;

export const StyledCheckbox = styled(Checkbox)`
  color: ${baseFontColor};
  a {
    margin-left: 5px;
    text-decoration: underline;
  }
  ${media.smallScreen`
    justify-content: center;
    margin-bottom: 0.7rem;
    input:checked + div {
      span {
        position: relative;
        &:after {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  `}
`;
